import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LancamentoFolhaListarRoutingModule } from './lancamento-folha-listar-routing.module';
import { LancamentoFolhaListarComponent } from './lancamento-folha-listar.component';
import { TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { MessagesModule } from 'primeng/messages';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { InputNumberModule } from 'primeng/inputnumber';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    LancamentoFolhaListarComponent
  ],
  imports: [
    CommonModule,
    LancamentoFolhaListarRoutingModule,
    FormsModule,
    TableModule,
    MessagesModule,
    ButtonModule,
    InputTextModule,
    CalendarModule,
    DropdownModule,
    DialogModule,
    ConfirmDialogModule,
    InputNumberModule,
    ProgressSpinnerModule
  ],
  providers: [ConfirmationService]
})
export class LancamentoFolhaListarModule { }
